module.exports = __webpack_public_path__ + "messenger-76343d2c8c6dc656344a.svg";